import { render, staticRenderFns } from "./cardWraper.vue?vue&type=template&id=298be42e"
import script from "./cardWraper.vue?vue&type=script&lang=js"
export * from "./cardWraper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports